import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { validateEmail } from "../../../utils/validation";
import { postFetch, processApiError } from "../../../utils/api";
import { BsCalendar } from "react-icons/bs";

const BookDemo = ({ show, close, setemail = "" }) => {
  const [error, setError] = useState({});
  const [ack, setAck] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    companySize: "",
    phoneNo: "",
    message: "",
  });

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      email: setemail,
    }));
  }, [setemail]);

  const handleChange = (value, field) => {
    debugger;
    if (field === "email") {
      const isValidate = validateEmail(value);
      setError((prev) => ({
        ...prev,
        email: !isValidate,
      }));
    }
    if (field === "phoneNo") {
      if (value === "" || /^[\d+#]+$/.test(value)) {
        const temp = { ...form };
        temp[field] = value;
        setForm(temp);
      }
      return;
    }
    const temp = { ...form };
    temp[field] = value;
    setForm(temp);
  };

  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();
    const payload = {
      firstname: form.firstName,
      lastname: form.lastName,
      email: form.email,
      companyname: form.companyName,
      companysize: form.companySize,
      phonenumber: form.phoneNo,
      description: form.message,
    };

    const err = {};
    if (!payload.firstname) {
      err.firstname = "can't remain empty";
    }
    if (!payload.lastname) {
      err.lastname = "can't remain empty";
    }
    if (!payload.email) {
      err.email = "can't remain empty";
    }
    if (!payload.companyname) {
      err.companyname = "can't remain empty";
    }
    if (!payload.companysize) {
      err.companysize = "can't remain empty";
    }
    if (!payload.phonenumber) {
      err.phonenumber = "can't remain empty";
    }

    if (Object.keys(err).length > 0) {
      setError(err);
      return;
    }

    handleSchedule();
    close();

    try {
      const { data, response } = await postFetch("account/book-demo/", payload);
      if (response.ok) {
        setForm({
          firstName: "",
          lastName: "",
          email: "",
          companyName: "",
          companySize: "",
          phoneNo: "",
          message: "",
        });
      } else {
        toast.error(processApiError(data) || "Error occurred");
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };
  const [schedule, setSchedule] = useState(false);
  const handleSchedule = () => {
    setSchedule(true);
  };
  return (
    <>
      <Modal show={show} onHide={close}>
        <Modal.Header>
          <h5 className="modal-title fw-bold">
            {" "}
            Please fill the form below &#9997;
          </h5>
          <button type="button" className="btn-close" onClick={close}></button>
        </Modal.Header>
        <Modal.Body>
          <div className="contact">
            <form method="post" role="form" className="php-email-form p-0">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    name="name"
                    style={{
                      border: error.firstname ? "1px solid red" : "",
                    }}
                    className="form-control"
                    id="fname"
                    placeholder="First Name"
                    value={form?.firstName}
                    onChange={(e) => {
                      handleChange(e.target.value, "firstName");
                      setError((prev) => ({
                        ...prev,
                        firstname: "",
                      }));
                    }}
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    name="name"
                    style={{
                      border: error?.lastname ? "1px solid red" : "",
                    }}
                    className="form-control"
                    id="lname"
                    placeholder="Last Name"
                    value={form.lastName}
                    onChange={(e) => {
                      handleChange(e.target.value, "lastName");
                      setError((prev) => ({
                        ...prev,
                        lastname: "",
                      }));
                    }}
                  />
                </div>
                <div className="col-md-12 mb-4">
                  <input
                    type="email"
                    className="form-control"
                    style={{
                      border: error?.email ? "1px solid red" : "",
                    }}
                    name="email"
                    id="email"
                    placeholder="Work Email"
                    value={form.email}
                    onChange={(e) => {
                      handleChange(e.target.value, "email");
                    }}
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      border: error?.companyname ? "1px solid red" : "",
                    }}
                    name="companyname"
                    id="companyname"
                    placeholder="Company Name"
                    value={form.companyName}
                    onChange={(e) => {
                      handleChange(e.target.value, "companyName");
                      setError((prev) => ({
                        ...prev,
                        companyname: "",
                      }));
                    }}
                  />
                </div>
                <div className="col-md-6 mb-4">
                  <select
                    className="form-select"
                    style={{
                      border: error?.companysize ? "1px solid red" : "",
                    }}
                    value={form.companySize}
                    onChange={(e) => {
                      handleChange(e.target.value, "companySize");
                      setError((prev) => ({
                        ...prev,
                        companysize: "",
                      }));
                    }}
                  >
                    <option value="">Company Size</option>
                    <option value="0-10">0-10</option>
                    <option value="11-50">11-50</option>
                    <option value="51-200">51-200</option>
                    <option value="201-500">201-500</option>
                    <option value="501-1000">501-1000</option>
                    <option value="1000+">1000+</option>
                  </select>
                </div>
                <div className="col-md-12 mb-4">
                  <input
                    type="text"
                    name="phname"
                    style={{
                      border: error?.phonenumber ? "1px solid red" : "",
                    }}
                    className="form-control"
                    id="phone"
                    placeholder="Phone Number"
                    value={form.phoneNo}
                    onChange={(e) => {
                      handleChange(e.target.value, "phoneNo");
                      setError((prev) => ({
                        ...prev,
                        phonenumber: "",
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="mb-3">
                <textarea
                  className="form-control"
                  name="message"
                  rows="5"
                  placeholder="Your Message"
                  value={form.message}
                  onChange={(e) => handleChange(e.target.value, "message")}
                ></textarea>
              </div>
              <div className="my-3">
                <div className="loading">Loading</div>
                <div className="error-message"></div>
                <div className="sent-message">
                  Your message has been sent. Thank you!
                </div>
              </div>
              <div className="form-check mb-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexCheckDefault"
                  checked={ack}
                  onChange={(e) => setAck(e.target.checked)}
                />
                <label className="form-check-label" for="flexCheckDefault">
                  I acknowledge the content of the{" "}
                  <Link
                    style={{ color: "#3c1d7a" }}
                    target="_blank"
                    to="/privacy-policy"
                  >
                    Vergado Privacy Policy
                  </Link>
                  .
                </label>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-100"
                  disabled={!ack}
                  onClick={handleSubmit}
                >
                  <BsCalendar
                    style={{ marginRight: "8px", marginBottom: "2px" }}
                    size={15}
                  />
                  Choose date & time
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={schedule} onHide={() => setSchedule(false)} size="xl">
        <Modal.Body
          style={{ position: "relative", height: "90vh", padding: 0 }}
        >
          <button
            onClick={() => setSchedule(false)}
            className="btn-close"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 10,
              background: "transparent",
              border: "none",
              fontSize: "2.5rem",
              color: "#000",
              cursor: "pointer",
            }}
            aria-label="Close"
          >
            &times;
          </button>
          <iframe
            src="https://calendly.com/sanchit-vergado/30min"
            title="Schedule Meeting"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            allowFullScreen
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BookDemo;
